var map = {
	"./AktualiDefault": "i6Ij",
	"./AktualiDefault.js": "i6Ij",
	"./App": "YCZr",
	"./App.js": "YCZr",
	"./DokumentiDefault": "pUlM",
	"./DokumentiDefault.js": "pUlM",
	"./DomeDefault": "krs1",
	"./DomeDefault.js": "krs1",
	"./IepirkumiDefault": "6YA4",
	"./IepirkumiDefault.js": "6YA4",
	"./LiepajniekiemPostDefault": "nxnD",
	"./LiepajniekiemPostDefault.js": "nxnD",
	"./Lists/CardsList": "kxnK",
	"./Lists/CardsList.js": "kxnK",
	"./Loading": "1C7C",
	"./Loading.js": "1C7C",
	"./Main": "fNQo",
	"./Main.js": "fNQo",
	"./NodokluZinojumiDefault": "hb2M",
	"./NodokluZinojumiDefault.js": "hb2M",
	"./NotFound": "w5ru",
	"./NotFound.js": "w5ru",
	"./PageBilzuGalerija": "Z+gi",
	"./PageBilzuGalerija.js": "Z+gi",
	"./PageCategory": "7yII",
	"./PageCategory.js": "7yII",
	"./PageDefault": "/WLP",
	"./PageDefault.js": "/WLP",
	"./PageDokumenti": "HZI6",
	"./PageDokumenti.js": "HZI6",
	"./PageDomesDeputati": "UuJc",
	"./PageDomesDeputati.js": "UuJc",
	"./PageDomesVadiba": "pdgI",
	"./PageDomesVadiba.js": "pdgI",
	"./PageHome": "+x1M",
	"./PageHome.js": "+x1M",
	"./PageIepirkumi": "BuUS",
	"./PageIepirkumi.js": "BuUS",
	"./PageIzsoles": "Ov1/",
	"./PageIzsoles.js": "Ov1/",
	"./PageJaunumi": "LRA9",
	"./PageJaunumi.js": "LRA9",
	"./PageKontakti": "YWbf",
	"./PageKontakti.js": "YWbf",
	"./PageLiepajniekiem": "POPQ",
	"./PageLiepajniekiem.js": "POPQ",
	"./PageNodokluZinojumi": "cuFC",
	"./PageNodokluZinojumi.js": "cuFC",
	"./PagePakalpojumi": "vL7t",
	"./PagePakalpojumi.js": "vL7t",
	"./PagePasvaldibasKontakti": "dU50",
	"./PagePasvaldibasKontakti.js": "dU50",
	"./PageProjekti": "qgCz",
	"./PageProjekti.js": "qgCz",
	"./PageRedirect": "peOW",
	"./PageRedirect.js": "peOW",
	"./PageSearch": "lWgy",
	"./PageSearch.js": "lWgy",
	"./PageSitemap": "tTfV",
	"./PageSitemap.js": "tTfV",
	"./PageUznemejiem": "i7U5",
	"./PageUznemejiem.js": "i7U5",
	"./PageVideo": "DzfO",
	"./PageVideo.js": "DzfO",
	"./PageVideoGalerija": "HSzK",
	"./PageVideoGalerija.js": "HSzK",
	"./PostDefault": "n2cJ",
	"./PostDefault.js": "n2cJ",
	"./ProjektiDefault": "kQfF",
	"./ProjektiDefault.js": "kQfF",
	"./UniversalLoading": "chqk",
	"./UniversalLoading.js": "chqk",
	"./UznemejiemPostDefault": "hQb9",
	"./UznemejiemPostDefault.js": "hQb9"
};
function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id])
		throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
	return __webpack_require__(id);
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "viIj";
module.exports = webpackContext;


//////////////////
// WEBPACK FOOTER
// ./src/components weak ^\.\/.*$
// module id = viIj
// module chunks = 35